<template>
  <TabPanel value="engage">
    <FeatureCard
      span="2"
      title="Engage your audience"
      bg-color="secondary"
      color="secondary"
    >
      <VText gutter-bottom
        >Use our many link types to create an engaging bio link that gets your
        visitors to engage with your content.
      </VText>

      <FeatureCardList component="ol">
        <li>Embed</li>
        <li>Carousel (1 slide)</li>
        <li>Carousel <Badge content="Pro" /></li>
      </FeatureCardList>

      <video
        slot="img"
        src="~/assets/videos/home/engage.mp4"
        loading="lazy"
        type="video/mp4"
        muted
        loop
        playsinline
        style="aspect-ratio: 16 / 9"
      />
    </FeatureCard>
  </TabPanel>
</template>

<script>
import { VText, TabPanel, Badge } from '@campsite-bio/component-lib';

import FeatureCard from '@/components/features/feature-card';
import FeatureCardList from '@/components/features/feature-card-list';

export default {
  components: {
    VText,
    TabPanel,
    Badge,
    FeatureCard,
    FeatureCardList,
  },

  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
